import { FolderStarIcon } from './FolderStarIcon';

/**
 * author: Google
 * id 58C8B00C-897C-4381-9AD2-33B754B96865
 * name folder-star
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-star.svg
 * tags
 * - Files / Folders 
 */
export const FolderSpecialIcon = FolderStarIcon;
export default FolderSpecialIcon